import React from "react"
import { Flex, FlexProps, Button as ChakraButton } from "@chakra-ui/core"
import { Filter, isAtLeastOneFilterApplied, toggleSelected } from "./utils"
import SelectedFilterButton from "../../components/SelectedFilterButton"

type SelectedFiltersProps = FlexProps & {
  filters: Filter[]
  setFilters: (filters: Filter[]) => void
}

export default function SelectedFilters({
  filters,
  setFilters,
  ...props
}: SelectedFiltersProps) {
  return (
    <Flex alignItems="center" mt="1rem" mb="1.375rem" {...props}>
      {filters?.reduce((acc, cur) => {
        return [
          ...acc,
          ...cur.options
            // Remove duplicate options
            .filter((v, i, a) => a.findIndex((v2) => v2.name === v.name) === i) //remove duplicate
            .filter((opt) => opt.selected)
            .map((opt) => (
              <SelectedFilterButton
                key={opt.name}
                mr="0.625rem"
                onClick={() =>
                  toggleSelected(cur.title, opt.name, filters, setFilters)
                }
              >
                {opt.title}
              </SelectedFilterButton>
            )),
        ]
      }, [])}
      {isAtLeastOneFilterApplied(filters) && (
        <ChakraButton
          variant="ghost"
          lineHeight="1.375rem"
          color="dawn"
          cursor="pointer"
          borderRadius="0.5rem"
          onClick={() => {
            setFilters(
              filters.map((filt) => ({
                ...filt,
                options: filt.options.map((opt) => ({
                  ...opt,
                  selected: false,
                })),
              }))
            )
          }}
        >
          Clear All
        </ChakraButton>
      )}
    </Flex>
  )
}
